import React from 'react';

const GraphEdge = ({ edge, nodes }) => {
    const nodeFrom = nodes.find(n => n.id === edge.from);
    const nodeTo = nodes.find(n => n.id === edge.to);

    if (!nodeFrom || !nodeTo) return null;

    const angle = Math.atan2(nodeTo.y - nodeFrom.y, nodeTo.x - nodeFrom.x) * 180 / Math.PI;
    const length = Math.sqrt(Math.pow(nodeTo.x - nodeFrom.x, 2) + Math.pow(nodeTo.y - nodeFrom.y, 2));

    const style = {
        top: `${nodeFrom.y}px`,
        left: `${nodeFrom.x}px`,
        width: `${length}px`,
        transform: `rotate(${angle}deg)`,
    };
    
    const labelStyle = {
        top: `${length / 2}px`,
        left: `0px`,
    };

    return (
        <div className="graph-edge" style={style}>
            {edge.label && <div className="graph-edge-label" style={labelStyle}>{edge.label}</div>}
        </div>
    );
};

export default GraphEdge;